import type { Development } from "@/services/developmentService";

const slugify = (value: string): string =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export function developmentHref(d: Development): string {
  if (d.link_interno && d.link_interno.trim() !== "") {
    return `/resorts/${encodeURIComponent(d.link_interno.trim())}`;
  }
  return `/resorts/${encodeURIComponent(slugify(d.name))}`;
}
